import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import Popup from 'reactjs-popup'
import Select from 'react-select'

const aStyle = {
  display: 'none',
}

const spanStyle = {
  color: '#F08922',
  fontWeight: 'bold',
}

const localizer = momentLocalizer(moment)

const customDayPropGetter = date => {
  if (date.getDay() === 0 || date.getDay() === 6) {
    return {
      className: 'special-day',
      style: {
        backgroundColor: '#f2f2f2',
      },
    }
  } else {
    return {}
  }
}

class CalendarTeamsoncall extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.oncall.colors) {
      this.state = {
        evs: props.oncall.events,
        open: false,
        date: '',
        person: '',
        id: '',
        swap: [],
        seeswap: false,
        seechange: false,
        seebuttons: true,
        open2: false,
        date2: '',
      }
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openSwap = this.openSwap.bind(this)
    this.closeSwap = this.closeSwap.bind(this)
    this.openChange = this.openChange.bind(this)
    this.closeChange = this.closeChange.bind(this)
    this.openModalCh = this.openModalCh.bind(this)
    this.closeModalCh = this.closeModalCh.bind(this)
  }

  openModal() {
    this.setState({ open: true, seeswap: false, seechange: false})
  }
  closeModal() {
    this.setState({ open: false, seeswap: false, seechange: false, seebuttons: true })
  }

  openSwap() {
    this.setState({ seeswap: true, seebuttons: false })
  }
  closeSwap() {
    this.setState({ seeswap: false, seebuttons: true })
  }

  openChange() {
    this.setState({ seechange: true, seebuttons: false })
  }
  closeChange() {
    this.setState({ seechange: false, seebuttons: true })
  }

  openModalCh() {
    this.setState({ open2: true })
  }
  closeModalCh() {
    this.setState({ open2: false })
  }


  handleSelectEvent(event) {
    const { id, title, start} = event
    const startn = new Date(start)
    const startv = new Date(startn.getTime() - (startn.getTimezoneOffset() * 60000)).toISOString()
    .replace(/T/, ' ')
    .replace(/\..+/, '')
    const stime = startv.split(' ')
    const d = new Date()
    const mth = d.getMonth() + 1
    const year = d.getFullYear()
    fetch('/api/v1/possible_swaps/' + this.props.oncall.team.id + '/' + this.props.oncall.user.id + '/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ swap: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
    this.setState({ date: stime[0].toString(), person: title, id: id })
    this.openModal()
  }

  handleSelect(event) {
    const {start} = event
    const startn = new Date(start)
    const startv = new Date(startn.getTime() - (startn.getTimezoneOffset() * 60000)).toISOString()
    .replace(/T/, ' ')
    .replace(/\..+/, '')
    const stime = startv.split(' ')
    const d = new Date()
    const mth = d.getMonth() + 1
    const year = d.getFullYear()
    fetch('/api/v1/possible_swaps/' + this.props.oncall.team.id + '/' + this.props.oncall.user.id + '/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ swap: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
    this.setState({ date2: stime[0].toString() })
    if (this.props.oncall.is_manager === true && this.props.oncall.team['oncall']){
      this.openModalCh()
    }
  }

  handleClickSwap(){
    this.openSwap()
  }

  handleClickChange(){
    this.openChange()
  }

  handleSaveChange(){
    const sel = document.getElementById('newchange')
    const iduserchange = sel.childNodes[1].value
    const formData = new FormData()
    formData.append('team_id', this.props.oncall.team.id)
    formData.append('on_call_date', this.state.date)
    formData.append('new_user_id', iduserchange)
    const urlf = '/api/v1/changeoncall'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      body: formData,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while changing on-calls! ' + err)
    })
  }

  handleSaveChangeEmp(){
    const sel = document.getElementById('newchangeemp')
    const iduserchange = sel.childNodes[1].value
    const formData = new FormData()
    formData.append('team_id', this.props.oncall.team.id)
    formData.append('on_call_date', this.state.date2)
    formData.append('new_user_id', iduserchange)
    const urlf = '/api/v1/changeoncall'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      body: formData,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while changing empty on-calls! ' + err)
    })
  }

  handleSaveSwap(){
    const sel = document.getElementById('others')
    const othersswap = sel.childNodes[1].value
    const dval = othersswap.split(', ')
    const formData = new FormData()
    formData.append('team_id', this.props.oncall.team.id)
    formData.append('date_swap_with', dval[0])
    formData.append('date_to_swap', this.state.date)
    formData.append('name_to_swap', this.state.person)
    const urlf = '/api/v1/swaponcall'
    const meth = 'POST'
    fetch(urlf, {
      method: meth,
      body: formData,
    })
    .then(response => response.json())
    .then(() => {
      document.getElementById('mylink').click()
    })
    .catch((err) => {
      console.error('Error while swapping on-calls! ' + err)
    })
  }

  render() {
    if (this.props.oncall.colors) {
      return <Fragment><a href={'/teams/' + this.props.oncall.team.id} id="mylink" style={aStyle}></a><div className="row"><div className="col-sm-6" style={{ paddingLeft: '0px', display: this.props.oncall.next_oncall !== '' ? 'block' : 'none'}}>Your next on-call<span style={spanStyle}> {this.props.oncall.next_oncall}</span></div></div><Popup open={this.state.open} onClose={this.closeModal}><div className="swapmodal" style={{margin: '25px'}}><a className="close" onClick={this.closeModal}>X</a>Selected date: {this.state.date}<br />Person on-call: {this.state.person}<br /><br /><div className="col-sm-12" style={{float: 'left', paddingLeft: '0px', display: this.state.seeswap === true ? 'block' : 'none'}}><div><p>Swap with:</p><Select id="others" name="other_swap" options={this.state.swap.swapwith}></Select><a href="#" id="saveswapcall" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleSaveSwap()}>Save</a><br /><br /></div></div><div className="col-sm-12" style={{float: 'left', paddingLeft: '0px', display: this.state.seechange === true ? 'block' : 'none'}}><div><p>New person on-call:</p><Select id="newchange" name="change_call" options={this.state.swap.allteam}></Select><a href="#" id="savechangecall" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleSaveChange()}>Save change</a><br /><br /></div></div><div style={{ display: this.state.seebuttons === true ? 'block' : 'none'}} className="row"><div className="col-sm-6" style={{ display: this.props.oncall.is_manager === true ? 'inline-block' : 'none'}}><a href="#" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleClickSwap()}>Swap</a></div><div className="col-sm-6" style={{ display: this.props.oncall.is_manager === true ? 'inline-block' : 'none'}}><a href="#" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleClickChange()}>Change</a></div><div className="col-sm-12" style={{ display: this.props.oncall.is_manager === false ? 'block' : 'none'}}><a href="#" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleClickSwap()}>Swap</a></div></div></div></Popup><Popup open={this.state.open2} onClose={this.closeModalCh}><div className="swapmodal" style={{margin: '25px'}}><a className="close" onClick={this.closeModalCh}>X</a>Selected date: {this.state.date2}<br /><br /><div className="col-sm-12" style={{float: 'left', paddingLeft: '0px'}}><div><p>New person on-call:</p><Select id="newchangeemp" name="change_call_emp" options={this.state.swap.allteam}></Select><a href="#" id="savechangecall" className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}} onClick={() => this.handleSaveChangeEmp()}>Change</a><br /><br /></div></div></div></Popup><div className="row"><Calendar localizer={localizer} events={this.state.evs} views={[ 'month' ]} culture={'en-GB'} selectable={true} popup={true} onSelectEvent={(ev) => this.handleSelectEvent(ev)} onSelectSlot={(ev) => this.handleSelect(ev)} startAccessor="start" endAccessor="end" defaultDate={moment().toDate()} style={{ height: 580, width: '100%' }} dayPropGetter={customDayPropGetter} onNavigate={date => { this.fetchData(this.props.oncall.team.id, this.props.oncall.user.id, date) } } eventPropGetter={
              (event) => {
                const newStyle = {
                  backgroundColor: 'lightgrey',
                  color: 'black',
                  borderRadius: '0px',
                  border: 'none',
                  height: '30px',
                }

                newStyle.backgroundColor = event.color

                return {
                  className: '',
                  style: newStyle,
                }
              }
            }></Calendar></div></Fragment>
    }
    return <div>Waiting</div>
  }

  fetchData(tid, uid, date) {
    const vrs = String(date).split(' ')
    const mth = date.getMonth() + 1
    fetch('/api/v1/show_team_oncall/' + tid + '/' + uid + '/' + mth + '/' + vrs[3], {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ evs: data.events })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

}

CalendarTeamsoncall.propTypes = {
  oncall: PropTypes.object,
}

export default CalendarTeamsoncall
